/** Missing or blank translations use the original merchant text, never another locale. */
export function resolveLocalizedText(values, locale, fallback) {
    if (locale !== 'ar' && locale !== 'en' && locale !== 'de' && locale !== 'nl')
        return fallback;
    return values?.[locale]?.trim() || fallback;
}
//# sourceMappingURL=localized-text.js.map